import { forwardRef, useState } from 'react';
import { Field } from 'formik';
import { FormControl, Stack, FormLabel, Box, Text } from '@chakra-ui/react';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import walkthroughIds from '../walkthroughIds';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    dropDownFormStyle,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import { Select } from 'chakra-react-select';
import { selectiveSyncOptions } from '../consts';

const ApprovalCodeSelectiveSyncPolicy = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { createMode } = walkthroughIds;
    const ChakraSelect = forwardRef((props, ref) => (
        <Select selectedOptionColor="brand" ref={ref} {...props} />
    ));
    ChakraSelect.displayName = "ChakraSelect";

    return (
        <FormControl
            isInvalid={!!errors.selectiveSyncPolicy && touched.selectiveSyncPolicy}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Selective Sync Policy
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Choose the selective sync policy for this approval code.
                    </Text>
                </Box>
                <Box
                    flex="1"
                    sx={{
                        paddingTop: '15px',
                    }}
                >
                    <Field name="selectiveSyncPolicy">
                        {({ form }) => {
                            const selectedOption = selectiveSyncOptions.find(
                                (op) => op.value === form.values.selectiveSyncPolicy
                            ) || null;
                            return (
                                <ChakraSelect
                                    minWidth="410px"
                                    width="100%"
                                    data-walkthroughid={createMode.ufSelectiveSyncSelect}
                                    options={selectiveSyncOptions}
                                    placeholder="- Select Sync Policy -"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                    getOptionLabel={(i) => i.label}
                                    getOptionValue={(i) => i.value}
                                    chakraStyles={dropDownFormStyle(darkMode)}
                                    isLoading={form.isSubmitting}
                                    isDisabled={form.isSubmitting}
                                    value={selectedOption}
                                    onChange={(option) => {
                                        form.setFieldValue('selectiveSyncPolicy', option.value);
                                        form.validateField('selectiveSyncPolicy');
                                    }}
                                    onBlur={() => {
                                        form.setFieldTouched('selectiveSyncPolicy', true);
                                    }}
                                />
                            );
                        }}
                    </Field>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Choose the selective sync policy for this approval code."
                        ariaLabel="approval-code-selective-sync-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default ApprovalCodeSelectiveSyncPolicy;